import { useState, useEffect, useContext } from "react";
import {
  Form,
  Input,  
  Typography,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "./users.css";
import secureLocalStorage from "react-secure-storage";

import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import CustomLoader from "../customLoader";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import TableContent from "../../../components/atoms/TableContent";
import AddUser from "./addUser";
import media from "../../../media";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchRoleAsDropdownThunk, fetchUsersThunk, fetchSupervisorAsDropdownThunk, fetchClientAsDopdownThunk } from "../../../store/thunks/usersThunk";

const Users = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const currentPath = location.pathname.replace("/", "");
  const [tableForm] = Form.useForm();

  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.muUsers,
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;
  
  //Search Filter
  const { Search } = Input;
  const [searchText, setSearchText] = useState("");
  
  const [clients, setClients] = useState([]);
  const [roles, setRoles] = useState([]);
  const [allManagers,setAllManagers] = useState([]);
  const [allReportingSupervisors, setAllReportingSupervisors] = useState([]);
  const [allAtls, setAllAtls] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const [statuses, setStatuses] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" },
  ]);

  const [editingKey, setEditingKey] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  const openAddModal = () => {
    setEditRecord(null);
    setModalOpen(true);
  };

  const openEditModal = (record) => {
    setEditRecord(record);
    setModalOpen(true);
  };

  const renderUserCell = (user) => {
    if (!user || typeof user !== "object") {
      return <span>-</span>;
    }

    const name = user.name || "-";
    const firstLetter = name.charAt(0).toUpperCase();

    return (
      <span className="rowStyle no-wrap profileText">
        {user.profilePicUrl ? (
          <img
            src={user.profilePicUrl}
            alt={name}
            className="tableProfile"
          />
        ) : (
          <span className="firstCaps">{firstLetter}</span>
        )}
        {name}
      </span>
    );
  };

  const renderClientCell = (client) => {
    if (!client || typeof client !== "object") {
      return <span>-</span>;
    }

    const name = client.name || "-";
    const firstLetter = name.charAt(0).toUpperCase();

    return (
      <span className="rowStyle no-wrap profileText">
        {name}
      </span>
    );
  };

  const columns = [
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            ID
          </div>
        );
      },
      dataIndex: "id",

      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.transactionId.svg} alt="icon" />
            Emp ID
          </div>
        );
      },
      dataIndex: "empID",

      editable: true,
      render: (text, row) => <span className="rowstyle">{text}</span>,
    },
    ,
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentIcon.svg} alt="icon" />
            Name
          </div>
        );
      },
      dataIndex: "name",

      editable: true,
      render: (text, row) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentIcon.svg} alt="icon" />
            Email
          </div>
        );
      },
      dataIndex: "email",

      editable: true,
      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentName.svg} alt="icon" />
            Role
          </div>
        );
      },
      dataIndex: "role",

      editable: true,
      render: (text) => (
        <span className="rowstyle">
          {text && text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.supervisor.svg} alt="icon" />
            Supervisor
          </div>
        );
      },
      dataIndex: "reportingSupervisor",

      editable: true,
      // render: (text) => <span className="rowstyle">{text ? text : ""}</span>,

      render: renderUserCell,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.supervisor.svg} alt="icon" />
            ATL
          </div>
        );
      },
      dataIndex: "atl",

      editable: true,
      // render: (text) => <span className="rowstyle">{text ? text : ""}</span>,
      render: renderUserCell,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditor.svg} alt="icon" />
            Client
          </div>
        );
      },
      dataIndex: "client",

      editable: true,
      // render: (text) => <span className="rowstyle">{text ? text : ""}</span>,
      render: renderClientCell,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentStatus.svg} alt="icon" />
            Status
          </div>
        );
      },
      dataIndex: "status",

      editable: true,
      
      render: (text, row) => (
        <span
          className={`cusStatus ${
            text?.toLowerCase() === "active" ? "cusActive" : "cusInActive"
          }`}
        >
          {text}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Created At
          </div>
        );
      },
      dataIndex: "createdAt",

      render: (text) => <span className="rowstyle">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Updated At
          </div>
        );
      },
      dataIndex: "updatedAt",
    },
    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => {
        return (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => openEditModal(record)}
            className="tableBtn bfont"
          >
            <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
          </Typography.Link>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editing: isEditing(record),        
        cellConfig: {
            inputType: "text",
            dataIndex: col.dataIndex,
            title: typeof col.title === "string" ? col.title : undefined,
            roles,
            clients,
            allReportingSupervisors,
            allAtls,
            statuses,
          },        
      }),
    };
  });

  /*begin::getSupervisors will fetch the list of ReportingSupervisors*/
  const getSupervisors = async () => {    
    const payload = {
      route: "users",
      action: "findAll",
      fields: ["manager", "tl", "atl"],
    };
    await dispatch(fetchSupervisorAsDropdownThunk(payload))
      .unwrap()
      .then((response) => {
        const storeAllMgrs = [];
        const getAllMgrs = response.filter((user) => user?.role === "manager");

        getAllMgrs?.map((user, index) => {
          storeAllMgrs.push({
            label: user?.name + " (EmpID: " + user?.empID + ")",
            value: user?._id,
          });
        });
        setAllManagers(storeAllMgrs);
        
        const storeAllTls = [];
        const getAllTls = response.filter(
          (user) => user?.role === "tl" || user?.role === "manager",
        );

        getAllTls?.map((user, index) => {
          storeAllTls.push({
            label: user?.name + " (EmpID: " + user?.empID + ")",
            value: user?._id,
          });
        });
        setAllReportingSupervisors(storeAllTls);

        const storeAllATls = [];
        const getAllATls = response.filter((user) => user?.role === "atl");

        getAllATls?.map((user, index) => {
          storeAllATls.push({
            label: user?.name + " (EmpID: " + user?.empID + ")",
            value: user?._id,
          });
        });
        setAllAtls(storeAllATls);
      })
      .catch((error) => {});
  };
  /*end::getSupervisors will fetch the list of Clients*/

  /*begin::getClients will fetch the list of Clients*/
  const getClients = async () => {
    const payload = { route: "clients", action: "findAll" };
    
    await dispatch(fetchClientAsDopdownThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((client, index) => {
          temp.push({ label: client?.name, value: client?._id });
        });
        setClients(temp);
      })
      .catch((error) => {});
  };
  /*end::getClients will fetch the list of Clients*/

  /*begin::getRoles will fetch the list of Roles*/
  const getRoles = async () => {    
    const payload = {};
    await dispatch(fetchRoleAsDropdownThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((role, index) => {
          temp.push({ label: role?.name, value: role?.name?.toLowerCase() });
        });
        setRoles(temp);
      })
      .catch((error) => {});
  };
  /*end::getRoles will fetch the list of Roles*/

  // Fetch users
  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        await dispatch(
          fetchUsersThunk({
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue,
            searchKeyword,
            route: currentPath,
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
          }),
        ).unwrap();
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
  }, [currentPath, pagination.current, pagination.pageSize, dispatch]);

  useEffect(() => {
    //getUserList();
    getRoles();
    getClients();
    getSupervisors();
  }, []);

  // Filter the storeList based on the searchText

  const searchFilterData =
    globalState.list &&
    globalState.list.filter((item) => {
      const role = item.role ? item.role.toLowerCase() : "";
      const empID = item.empID ? item.empID : "";
      const name = item.name ? item.name.toLowerCase() : "";
      const email = item.email ? item.email : "";
      const client = item.client ? item.client.toLowerCase() : "";
      const status = item.status ? item.status.toLowerCase() : "";

      return (
        role.includes(searchText.toLowerCase()) ||
        empID === Number(searchText) ||
        name.includes(searchText.toLowerCase()) ||
        email.includes(searchText) ||
        client.includes(searchText.toLowerCase()) ||
        status.includes(searchText.toLowerCase())
      );
    });

  const isEditing = (record) => record.key === editingKey;
 
  return (
    <div className="all-content">
      <CustomLoader showLoader={showLoader} />
      <TopContainerHeader
        sectionTitle="Users"
        sectionDescription={showLoader ? "Loading..." : `${count || 0} Found`}
        hasSectionButton={true}
        sectionButtons={[
          {
            isVisible: true,
            itemType: "add",
            itemName: "Add",
            onClick: openAddModal,
          },
        ]}
        hasFilter={false}
        buttonTitle="Add New"
        FormComponent={AddUser}
        formTitle={editRecord ? "Edit User" : "Add User"}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        formProps={{
          editData: editRecord,
          clients,
          roles,
          reportingSupervisors:allReportingSupervisors,
          allManagers,
          allAtls,
          statuses,
          onSuccess: () => {
            dispatch(
              fetchUsersThunk({
                searchIn: currentPath,
                callActionFrom: currentPath,
                hasSearchedValue: secureLocalStorage.getItem("hasSearchedValue")
                    ? "yes"
                    : "",
                searchKeyword: secureLocalStorage.getItem("searchKeyword") || "", 
                route: currentPath,
                pagination: {
                  current: pagination.current,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                },
              })
            );
            setModalOpen(false);
          },
        }}
      />

      <div className="all-table-holder">
        <Form form={tableForm} component={false}>
          <TableContent
            className=""
            rowSelection=""
            rowClassName="editable-row"
            bordered={false}
            columns={mergedColumns}
            dataSource={list}
            pagination={tablePagination}
          />
        </Form>
      </div>
    </div>
  );
};
export default Users;
